var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReviewPositive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 45.1 39.5 L 45.1 7.55 C 45.1 6.317 44.65 5.242 43.75 4.325 C 42.85 3.408 41.783 2.95 40.55 2.95 L 7.55 2.95 C 6.317 2.95 5.242 3.408 4.325 4.325 C 3.408 5.242 2.95 6.317 2.95 7.55 L 2.95 32.6 C 2.95 33.833 3.408 34.9 4.325 35.8 C 5.242 36.7 6.317 37.15 7.55 37.15 L 37.25 37.15 L 41.2 41.1 C 42 41.9 42.85 42.1 43.75 41.7 C 44.65 41.3 45.1 40.567 45.1 39.5 Z",
    fill: "rgb(0, 194, 74)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 5 L 5 10",
    fill: "transparent",
    strokeWidth: 5,
    stroke: "hsl(0, 0%, 100%)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 0 L 5 10",
    fill: "transparent",
    strokeWidth: 5,
    stroke: "hsl(0, 0%, 100%)",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviewPositive);
export default __webpack_public_path__ + "static/media/icon-review-positive.2e2e654f.svg";
export { ForwardRef as ReactComponent };